<template>
    <transition name="fade">
        <div v-if="baModalOpen" class="modal buy-again-modal" tabindex="-1" ref="buyAgainModal">
            <div class="modal-dialog shadow">
                <div class="modal-content p-0">
                    <div class="modal-header bg-secondary text-center">
                        <h5 class="modal-title flex-fill text-white">Hold up! We've seen <span>{{ order.registration }}</span> before</h5>
                    </div>
                    <div class="modal-body row">
                        <p class="last-order mb-3">The last order for your <b>{{ order.make }} {{ order.model }}</b> was at <b>{{ order.fitter.name }}</b> with these tyres, do you want to repeat the order?</p>
                        <div class="tyre col-12 col-sm-6" v-if="order.tyre">
                            <b class="d-block text-center">Tyre</b>
                            <hr>
                            <div class="row row-mh">
                                <div class="col-6">
                                    <img :src="brandImagePath" class="img-fluid" :alt="order.tyre.brand + ' logo'" />
                                    <b>{{ order.tyre.brand }}</b>
                                    <p class="mb-0">{{ order.tyre.pattern }}</p>
                                    <p class="mb-0">{{ order.tyre.size }} {{ order.tyre.load_speed }}</p>
                                    <b class="d-block">&pound;{{ order.tyre.retail}}</b>
                                    <small class="d-block">per tyre</small>
                                </div>
                                <div class="col-6">
                                    <div class="img-wrap">
                                        <img :src="imageBasePath + order.tyre.graphic" class="img-fluid" :alt="order.tyre.brand + order.tyre.pattern + ' image'" @error="replaceTyreOnError"/>
                                    </div>
                                    <rating-labels :fuel="order.tyre.fuel" :wet="order.tyre.wet" :decibels="order.tyre.decibels" :noise-rating="order.tyre.noise_rating"></rating-labels>
                                </div>
                            </div>
                            <hr>
                            <a :href="regenerateBasketUrl + regenerateBasketTyresUrl" class="btn btn-primary btn-sm w-100 buy-again-btn" @click="trackTyre()">
                                <span>Yes, tyre only</span>
                            </a>
                        </div>
                        <div class="fitter col-12 col-sm-6 mt-4 mt-sm-0">
                            <b class="d-block text-center">Garage</b>
                            <hr>
                            <div class="row-mh">
                                <b class="d-block">{{ order.fitter.name }}</b>
                                <p class="d-block mb-0">{{ order.fitter.address_line_one }}</p>
                                <p class="d-block mb-0">{{ order.fitter.address_line_two }}</p>
                                <p class="d-block mb-0">{{ order.fitter.address_line_three }}</p>
                                <p class="d-block mb-0">{{ order.fitter.town }}</p>
                                <p class="d-block mb-0 postcode uppercase">{{ order.fitter.postcode }}</p>
                                <div class="d-block mt-1" v-if="order.fitter.opening_times.weekday != '00:00-00:00'">
                                    <b>Mon-Fri:</b>
                                    <p class="d-inline-block mb-0 ms-1">{{ order.fitter.opening_times.weekday }}</p>
                                </div>
                                <div class="d-inline-block" v-if="order.fitter.opening_times.saturday != '00:00-00:00'">
                                    <b>Sat:</b>
                                    <p class="d-inline-block mb-0 ms-1">{{ order.fitter.opening_times.saturday }}</p>
                                </div>
                                <div class="d-inline-block ms-3" v-if="order.fitter.opening_times.sunday != '00:00-00:00'">
                                    <b>Sun:</b> 
                                    <p class="d-inline-block mb-0 ms-1">{{ order.fitter.opening_times.sunday }}</p>
                                </div>
                            </div>
                            <hr>
                            <a :href="regenerateBasketUrl + regenerateBasketFitterUrl" class="btn btn-sm w-100 btn-primary buy-again-btn" @click="trackFitter()">
                                <span>Yes, fitter only</span>
                            </a>
                        </div>
                        <div class="col-12">
                            <a :href="regenerateBasketFitterAndTyresUrl" class="btn btn-primary btn-sm mt-3 w-100 buy-again-btn js-same-again" @click="trackFitterAndTyres()">
                                <span>Yes, the same again please</span>
                            </a>
                            <p class="my-2 text-center">Or <a :href="baseUrl + '/confirm-size'" @click="trackSelectedOwn()">select your own tyres and fitter</a></p>
                            <p class="my-2 text-center">To prevent this window from appearing again, please <span class="text-underline cursor-pointer" @click="setCookieToPreventModal()">click here</span></p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['order', 'ba-modal-open', 'imageBasePath'],
        updated() {
            this.$root.initTooltip()
        },
        methods: {
            replaceTyreOnError(e) {
                e.target.src = this.imageBasePath + 'coming_soon.png';
            },
            async setCookieToPreventModal() {
                
                var response = await axios.post('/ajax/set_dont_show_buy_again_modal');

                //Track don't show again selection
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('BuyAgainModal', {
                        'event_category' : 'BuyAgainModal',
                        'event_label': '/dont-show-again'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }

                if(response.data.cookie_set == true) {
                    window.location.href = this.baseUrl + '/confirm-size';
                }
            },
            trackFitterAndTyres() {
                //Track Fitter and Tyres selection
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('BuyAgainModal', {
                        'event_category' : 'BuyAgainModal',
                        'event_label': '/same-again'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
            },
            trackTyre() {
                //Track Tyres selection
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('BuyAgainModal', {
                        'event_category' : 'BuyAgainModal',
                        'event_label': '/tyre-only'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
            },
            trackFitter() {
                //Track Fitter selection
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('BuyAgainModal', {
                        'event_category' : 'BuyAgainModal',
                        'event_label': '/fitter-only'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
            },
            trackSelectedOwn() {
                //Track selected own option
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('BuyAgainModal', {
                        'event_category' : 'BuyAgainModal',
                        'event_label': '/selected-own'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
            }
        },
        computed: {
            formattedSize() {
                var previousSize = this.order.tyre.size.split('/');
                var formattedPreviousSize = previousSize[0] + '-' + previousSize[1].replace('R', '-');

                return formattedPreviousSize;
            },
            brandImagePath() {
                return (this.imageBasePath + 'brand_logos/' + (this.order.tyre.brand_image != null ? this.order.tyre.brand_image : 'generic.png'));
            },
            regenerateBasketUrl() {
                return this.baseUrl + '/regenerate_basket?';
            },
            regenerateBasketTyresUrl() {
                return 'products[1][st_code]=' + this.order.tyre.st_code + '&products[1][quantity]=1';
            },
            regenerateBasketFitterUrl() {
                return 'fitter_id=' + this.order.fitter.account_number + (Object.keys(this.order.tyre).length > 0 ? '&tyre_size=' + this.formattedSize : '');
            },
            regenerateBasketFitterAndTyresUrl() {
                return this.regenerateBasketUrl + this.regenerateBasketFitterUrl + '&' + this.regenerateBasketTyresUrl;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
	}
    .buy-again-modal {
        .modal-dialog {
            max-width: 720px;
        }
        .modal-body {
            .last-order {
                @media screen and (min-width: 768px) {
                    max-width: 80%;
                }
                margin: 0 auto;
                text-align: center;
                font-size: 17px;
            }
            .tyre {
                .img-wrap {
                    max-height: 70px;
                    overflow: hidden;
                    margin-bottom: 10px;
                }
            }
            .fitter {
                p {
                    &:not(.postcode) {
                        text-transform: lowercase;
                        &:first-letter {
                            text-transform: uppercase;
                        }
                    }
                }
            }
            .row-mh {
                min-height: 200px;
            }
        }
    }
</style>